const user = {
  addUser: 'Thêm người dùng',
  editUser: 'Chỉnh sửa người dùng',
  firstName: 'Họ',
  requireFirstName: 'Trường Họ và tên yêu cầu phải nhập',
  lastName: 'Tên',
  fullName: 'Họ và tên',
  phoneNumber: 'Số điện thoại',
  requirePhone: 'Trường Số điện thoại yêu cầu phải nhập',
  role: 'Vai trò',
  requireRole: 'Trường Vai trò yêu cầu phải nhập',
  email: 'Email',
  requireEmail: 'Trường Email yêu cầu phải nhập',
  password: 'Mật khẩu',
  requirePassword: 'Trường Mật khẩu yêu cầu phải nhập',
  retypePassword: 'Nhập lại mật khẩu',
  requireRetypePassword: 'Trường Nhập lại mật khẩu yêu cầu phải nhập',
  accessAllTargets: 'Truy cập tất cả các mục tiêu',
  configGroupAccess: 'Cấu hình quyền truy cập nhóm mục tiêu',
  groupName: 'Tên nhóm',
  description: 'Mô tả',
  save: 'Lưu',
  cancel: 'Huỷ',
  error: 'Xảy ra lỗi',
  invalid: 'Sai định dạng',
  tryAnotherEmail: 'Xảy ra lỗi. Thử lại với email khác',

  users: 'Danh sách người dùng',
  twoFactorAuthenticate: 'Xác minh hai bước',
  userEnabled: 'Người dùng đã kích hoạt',
  userLocked: 'Người dùng bị khoá',
  name: 'Tên',

  enable: 'Kích hoạt',
  lock: 'Khoá',
  delete: 'Xoá',

  reset: 'Đặt lại',

  accountSetting: 'Cài đặt người dùng',
  passwordSetting: 'Cài đặt mật khẩu',
  passwordHistory: 'Lịch sử mật khẩu',
  passwordMaxAge: 'Thời gian hết hạn mật khẩu',
  enableTwoFactorAuthenticate: 'Kích hoạt xác minh hai bước',
  sessionAndLogoutSettings: 'Cài đặt session và đăng xuất',
  sessionTimeout: 'Thời gian hết hạn session (phút)',
  maximumConsecutiveLoginFailue: 'Số lần đăng nhập thất bại tối đa',
  timeWindow: 'Thời gian khoá tài khoản (phút)',
  lockoutTime: 'Thời gian mở khoá tài khoản (phút)',
  passwordHistoryTextHelper:
    'Số lượng mật khẩu mới độc nhất trước khi có thể sử dụng lại mật khẩu cũ. Giá trị 0 là không sử dụng chức năng',
  passwordMaxAgeTextHelper:
    'Số ngày mà mật khẩu có thể được sử dụng trước khi người dùng được yêu cầu thay đổi mật khẩu. Giá trị 0 là không sử dụng chức năng',
  timeoutTextHelper:
    'Phiên đăng nhập của người dùng sẽ hết hạn và yêu cầu đăng nhập lại sau thời gian này. Giá trị 0 là không sử dụng chức năng',
  maximumConsecutiveTextHelper:
    'Số lần đăng nhập thất bại tối đa trước khi người dùng bị khoá tài khoản. Giá trị 0 là không sử dụng chức năng',
  timeWindowTextHelper:
    'Thời gian tài khoản sẽ bị khoá sau khi lỗi đăng nhập thất bại liên tiếp xảy ra. Giá trị 0 là không sử dụng chức năng',
  lockTimeTextHelper:
    'Thời gian tài khoản có thể được đăng nhập trở lại sau khi bị khoá. Giá trị 0 là không sử dụng chức năng',

  requiredPasswordHistory: 'Trường Lịch sử mật khẩu yêu cầu phải nhập',
  requiredPasswordMaxAge: 'Trường Thời gian hết hạn mật khẩu yêu cầu phải nhập',
  requiredSessionTimeout: 'Trường Thời gian hết hạn session yêu cầu phải nhập',
  requiredMaximumConsecutiveLoginFailue:
    'Trường Số lần đăng nhập thất bại tối đa yêu cầu phải nhập',
  requiredTimeWindow: 'Trường Thời gian khoá tài khoản yêu cầu phải nhập',
  requireLockoutTime: 'Trường Thời gian mở khoá tài khoản yêu cầu phải nhập',

  createUserNotSuccess: 'Tạo người dùng không thành công',
  createUserSuccess: 'Tạo người dùng thành công',
  updateUserNotSuccess: 'Cập nhật người dùng không thành công',
  updateUserSuccess: 'Cập nhật người dùng thành công',
  deleteUserNotSuccess: 'Xoá người dùng không thành công',
  deleteUserSuccess: 'Xoá người dùng thành công',
  enableUserSuccess: 'Kích hoạt người dùng thành công',
  disableUserSuccess: 'Ngừng kích hoạt người dùng thành công',

  changePassword: 'Thay đổi mật khẩu',
  requiredOldPassword: 'Trường Mật khẩu cũ yêu cầu phải nhập',
  requiredNewPassword: 'Trường Mật khẩu mới yêu cầu phải nhập',
  oldPassword: 'Mật khẩu cũ',
  newPassword: 'Mật khẩu mới',
  newPasswordRetype: 'Nhập lại mật khẩu mới',
  requiredNewPasswordRetype: 'Trường Mật khẩu mới yêu cầu phải nhập',
  passWordDoNotMatch: 'Mật khẩu không khớp',
  changePasswordSuccess: 'Thay đổi mật khẩu thành công',

  min8: 'Tối thiểu 8 ký tự'
};

export default user;
